const Formater = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "NGN",
    // minimumFractionDigits: 2,
    // maximumFractionDigits: 2,
  });
export default Formater;